import { useMutation } from '@tanstack/react-query'
import { httpClientPrivate } from '@/libs/httpClient'
import config from '@/config'
import { UploadDocumentClaimResponse } from './types'

// Large files (up to 1 GB) can take minutes to stream up, so the client must
// wait well beyond the old 10s cap. See SA-8384.
const UPLOAD_TIMEOUT_MS = 7 * 60 * 1000 // 7 minutes

const uploadClaimDocument = async (
  file: File,
  documentTypeCode: string,
  onProgress?: (percent: number) => void,
): Promise<UploadDocumentClaimResponse> => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('documentTypeCode', documentTypeCode)

  const response = await httpClientPrivate.post(
    `${config.restUrl}/v1/backoffice/e-claim/claim-documents`,
    formData,
    {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: UPLOAD_TIMEOUT_MS,
      onUploadProgress: (event) => {
        if (!onProgress || !event.total) return
        onProgress(Math.round((event.loaded / event.total) * 100))
      },
    },
  )

  return response.data
}

const useClaimDocumentUpload = (
  documentTypeCode: string,
  onProgress?: (percent: number) => void,
) => {
  const mutation = useMutation({
    mutationKey: ['useClaimDocumentUpload', documentTypeCode],
    mutationFn: async (file: File) => uploadClaimDocument(file, documentTypeCode, onProgress),
  })

  return mutation
}

export { useClaimDocumentUpload }
